import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const PHLPv2Icon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/phlpv2icon.png" style={style} />
}
